
// import React, { useState, useEffect } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Box, Spinner, Text, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
//   ModalBody, ModalCloseButton, useDisclosure, useToast, FormControl, FormLabel, Input
// } from '@chakra-ui/react';
// import Cookies from 'js-cookie';
// import UserService from '../../services/UserService'; // Import your service
// import UserUpdateForm from './UserUpdateForm '; // Import the update form component
// import Api from '../../api/ApiUrl';
// import CustomSpinner from '../EndedAuctions/CustomSpinner';

// const UserDetails = () => {
//   const { userId } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const queryClient = useQueryClient();
//   const { isOpen: isDepositOpen, onOpen: onDepositOpen, onClose: onDepositClose } = useDisclosure();
//   const { isOpen: isWithdrawOpen, onOpen: onWithdrawOpen, onClose: onWithdrawClose } = useDisclosure();
//   const { data, isLoading, error, refetch } = useQuery(['user', userId], () => UserService.fetchUserDetails(userId));
//   const [amount, setAmount] = useState('');
//   const [isUpdateOpen, setIsUpdateOpen] = useState(false);
//   const [actionType, setActionType] = useState(null);

//   const user = data?.data?.data;

//   const userCookie = Cookies.get('user');  // Get the cookie value

//   // Check if the cookie is defined before parsing
//   const adminId = userCookie ? JSON.parse(userCookie)?._id ?? '' : '';

//   const depositMutation = useMutation(
//     ({ userId, amount, adminId }) => UserService.deposit(userId, amount, adminId),
//     {
//       onSuccess: () => {
//         toast({
//           title: 'Deposit successful',
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         queryClient.invalidateQueries(['user', userId]);
//         onDepositClose();
//         setAmount('');
//       },
//       onError: (error) => {
//         toast({
//           title: 'An error occurred',
//           description: error.response?.data?.message || 'Unable to perform deposit',
//           status: 'error',
//           duration: 3000,
//           isClosable: true,
//         });
//       },
//     }
//   );

//   const withdrawMutation = useMutation(
//     ({ userId, amount, adminId }) => UserService.withdraw(userId, amount, adminId),
//     {
//       onSuccess: () => {
//         toast({
//           title: 'Withdrawal successful',
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         queryClient.invalidateQueries(['user', userId]);
//         onWithdrawClose();
//         setAmount('');
//       },
//       onError: (error) => {
//         toast({
//           title: 'An error occurred',
//           description: error.response?.data?.message || 'Unable to perform withdrawal',
//           status: 'error',
//           duration: 3000,
//           isClosable: true,
//         });
//       },
//     }
//   );

//   const handleAction = () => {
//     if (amount <= 0) {
//       toast({
//         title: 'Invalid amount',
//         description: 'Amount must be greater than zero',
//         status: 'warning',
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }
//     if (actionType === 'deposit') {
//       depositMutation.mutate({ userId, amount, adminId });
//     } else if (actionType === 'withdraw') {
//       withdrawMutation.mutate({ userId, amount, adminId });
//     }
//   };

//   if (isLoading) {
//     return <CustomSpinner />;
//   }

//   if (error) {
//     return <Box>Error loading user details.</Box>;
//   }

//   return (
//     <Box p={5} shadow="md" borderWidth="1px">
//       <Text fontSize="xl" mb={4}>User Details</Text>
//       <Box mb={4}>
//         <Text><strong>Name:</strong> {user?.name}</Text>
//         <Text><strong>Email:</strong> {user?.email}</Text>
//         <Text><strong>Phone Number:</strong> {user?.phoneNumber}</Text>
//         <Text color={'green'} fontSize={'20px'}><strong>Wallet Balance:</strong> {user?.walletBalance}</Text>
//         <Text><strong>Company Name:</strong> {user?.companyname}</Text>
//         <Text><strong>Address:</strong> {user?.address}</Text>
//         <Text><strong>Specialist:</strong> {user?.specialist}</Text>
//         <Text><strong>Birthdate:</strong> {user?.birthdate?new Date(user.birthdate).toLocaleDateString():'not applied'}</Text>
//         <Text><strong>Verified:</strong> {user?.verified ? 'Yes' : 'No'}</Text>
//         <Text><strong>Blocked:</strong> {user?.blocked ? 'Yes' : 'No'}</Text>
//         <Text><strong>admin approved:</strong> {user?.approved ? 'Yes' : 'No'}</Text>
//         <Text><strong>ID Number:</strong> {user?.idNumber}</Text>
//         <Text><strong>ID Front Image:</strong> <img src={`${Api}/${user?.idImage?.path}`} alt="ID" /></Text>
//         <Text><strong>ID Back Image:</strong> <img src={`${Api}/${user?.idbackImage?.path}`} alt="ID Back image" /></Text>
//         <Text><strong>Created At:</strong> {new Date(user?.createdAt).toLocaleDateString()}</Text>
//       </Box>
//       <Button colorScheme="blue" onClick={() => setIsUpdateOpen(true)}>Update</Button>
//       <Button ml={3} colorScheme="teal" onClick={() => { setActionType('deposit'); onDepositOpen(); }}>Add Money</Button>
//       <Button ml={3} colorScheme="red" onClick={() => { setActionType('withdraw'); onWithdrawOpen(); }}>Withdraw</Button>

//       <Modal isOpen={isDepositOpen || isWithdrawOpen} onClose={actionType === 'deposit' ? onDepositClose : onWithdrawClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>{actionType === 'deposit' ? 'Deposit Money' : 'Withdraw Money'}</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <FormControl>
//               <FormLabel>Amount</FormLabel>
//               <Input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
//             </FormControl>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme={actionType === 'deposit' ? 'blue' : 'red'} mr={3} onClick={handleAction}>
//               {actionType === 'deposit' ? 'Deposit' : 'Withdraw'}
//             </Button>
//             <Button variant="ghost" onClick={actionType === 'deposit' ? onDepositClose : onWithdrawClose}>Cancel</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//       <Modal isOpen={isUpdateOpen} onClose={() => setIsUpdateOpen(false)}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Update User</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <UserUpdateForm user={user} onClose={() => { setIsUpdateOpen(false); refetch(); }} />
//           </ModalBody>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default UserDetails;











// import React, { useState } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Box, Spinner, Text, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
//   ModalBody, ModalCloseButton, useDisclosure, useToast, FormControl, FormLabel, Input
// } from '@chakra-ui/react';
// import Cookies from 'js-cookie';
// import UserService from '../../services/UserService'; // Import your service
// import UserUpdateForm from './UserUpdateForm '; // Import the update form component
// import Api from '../../api/ApiUrl';
// import CustomSpinner from '../EndedAuctions/CustomSpinner';

// const UserDetails = () => {
//   const { userId } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const queryClient = useQueryClient();
//   const { isOpen: isDepositOpen, onOpen: onDepositOpen, onClose: onDepositClose } = useDisclosure();
//   const { isOpen: isWithdrawOpen, onOpen: onWithdrawOpen, onClose: onWithdrawClose } = useDisclosure();
//   const { data, isLoading, error, refetch } = useQuery(['user', userId], () => UserService.fetchUserDetails(userId));
//   const [amount, setAmount] = useState('');
//   const [isUpdateOpen, setIsUpdateOpen] = useState(false);
//   const [actionType, setActionType] = useState(null);
//   const [isActionLoading, setIsActionLoading] = useState(false);

//   const user = data?.data?.data;

//   const userCookie = Cookies.get('user');  // Get the cookie value

//   // Check if the cookie is defined before parsing
//   const adminId = userCookie ? JSON.parse(userCookie)?._id ?? '' : '';

//   const depositMutation = useMutation(
//     ({ userId, amount, adminId }) => UserService.deposit(userId, amount, adminId),
//     {
//       onMutate: () => setIsActionLoading(true),
//       onSuccess: () => {
//         toast({
//           title: 'Deposit successful',
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         queryClient.invalidateQueries(['user', userId]);
//         onDepositClose();
//         setAmount('');
//       },
//       onError: (error) => {
//         toast({
//           title: 'An error occurred',
//           description: error.response?.data?.message || 'Unable to perform deposit',
//           status: 'error',
//           duration: 3000,
//           isClosable: true,
//         });
//       },
//       onSettled: () => setIsActionLoading(false),
//     }
//   );

//   const withdrawMutation = useMutation(
//     ({ userId, amount, adminId }) => UserService.withdraw(userId, amount, adminId),
//     {
//       onMutate: () => setIsActionLoading(true),
//       onSuccess: () => {
//         toast({
//           title: 'Withdrawal successful',
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         queryClient.invalidateQueries(['user', userId]);
//         onWithdrawClose();
//         setAmount('');
//       },
//       onError: (error) => {
//         toast({
//           title: 'An error occurred',
//           description: error.response?.data?.message || 'Unable to perform withdrawal',
//           status: 'error',
//           duration: 3000,
//           isClosable: true,
//         });
//       },
//       onSettled: () => setIsActionLoading(false),
//     }
//   );

//   const handleAction = () => {
//     if (amount <= 0) {
//       toast({
//         title: 'Invalid amount',
//         description: 'Amount must be greater than zero',
//         status: 'warning',
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }
//     if (actionType === 'deposit') {
//       depositMutation.mutate({ userId, amount, adminId });
//     } else if (actionType === 'withdraw') {
//       withdrawMutation.mutate({ userId, amount, adminId });
//     }
//   };

//   if (isLoading) {
//     return <CustomSpinner />;
//   }

//   if (error) {
//     return <Box>Error loading user details.</Box>;
//   }
// console.log(user)
//   return (
//     <Box p={5} shadow="md" borderWidth="1px">
//       <Text fontSize="xl" mb={4}>User Details</Text>
//       <Box mb={4}>
//         <Text><strong>Name:</strong> {user?.name}</Text>
//         <Text><strong>Email:</strong> {user?.email}</Text>
//         <Text><strong>Phone Number:</strong> {user?.phoneNumber}</Text>
//         <Text color={'green'} fontSize={'20px'}><strong>Wallet Balance:</strong> {user?.walletBalance}</Text>
//         <Text><strong>Company Name:</strong> {user?.companyname}</Text>
//         <Text><strong>Address:</strong> {user?.address}</Text>
//         <Text><strong>Specialist:</strong> {user?.specialist}</Text>
//         <Text><strong>Birthdate:</strong> {user?.birthdate ? new Date(user.birthdate).toLocaleDateString() : 'not applied'}</Text>
//         <Text><strong>Verified:</strong> {user?.verified ? 'Yes' : 'No'}</Text>
//         <Text><strong>Blocked:</strong> {user?.blocked ? 'Yes' : 'No'}</Text>
//         <Text><strong>admin approved:</strong> {user?.approved ? 'Yes' : 'No'}</Text>
//         <Text><strong>ID Number:</strong> {user?.idNumber}</Text>
//         <Text><strong>ID Front Image:</strong> <img src={`${Api}/${user?.idImage?.path}`} alt="ID" /></Text>
//         <Text><strong>ID Back Image:</strong> <img src={`${Api}/${user?.idbackImage?.path}`} alt="ID Back image" /></Text>
//         <Text><strong>Created At:</strong> {new Date(user?.createdAt).toLocaleDateString()}</Text>
//       </Box>
//       <Button colorScheme="blue" onClick={() => setIsUpdateOpen(true)}>Update</Button>
//       <Button
//         ml={3}
//         colorScheme="teal"
//         onClick={() => { setActionType('deposit'); onDepositOpen(); }}
//       >
//         Add Money
//       </Button>
//       <Button
//         ml={3}
//         colorScheme="red"
//         onClick={() => { setActionType('withdraw'); onWithdrawOpen(); }}
//       >
//         Withdraw
//       </Button>

//       <Modal isOpen={isDepositOpen || isWithdrawOpen} onClose={actionType === 'deposit' ? onDepositClose : onWithdrawClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>{actionType === 'deposit' ? 'Deposit Money' : 'Withdraw Money'}</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <FormControl>
//               <FormLabel>Amount</FormLabel>
//               <Input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
//             </FormControl>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme={actionType === 'deposit' ? 'blue' : 'red'} mr={3} onClick={handleAction} isLoading={isActionLoading}>
//               {actionType === 'deposit' ? 'Deposit' : 'Withdraw'}
//             </Button>
//             <Button variant="ghost" onClick={actionType === 'deposit' ? onDepositClose : onWithdrawClose}>Cancel</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//       <Modal isOpen={isUpdateOpen} onClose={() => setIsUpdateOpen(false)}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Update User</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <UserUpdateForm user={user} onClose={() => { setIsUpdateOpen(false); refetch(); }} />
//           </ModalBody>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default UserDetails;

































import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box, Text, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
  ModalBody, ModalCloseButton, useDisclosure, useToast, FormControl, FormLabel, Input, Table, Thead, Tbody, Tr, Th, Td
} from '@chakra-ui/react';
import Cookies from 'js-cookie';
import UserService from '../../services/UserService'; 
import UserUpdateForm from './UserUpdateForm '; 
import Api from '../../api/ApiUrl';
import CustomSpinner from '../EndedAuctions/CustomSpinner';

const UserDetails = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen: isDepositOpen, onOpen: onDepositOpen, onClose: onDepositClose } = useDisclosure();
  const { isOpen: isWithdrawOpen, onOpen: onWithdrawOpen, onClose: onWithdrawClose } = useDisclosure();
  const { isOpen: isTransactionsOpen, onOpen: onTransactionsOpen, onClose: onTransactionsClose } = useDisclosure();
  const { data, isLoading, error, refetch } = useQuery(['user', userId], () => UserService.fetchUserDetails(userId));
  const [amount, setAmount] = useState('');
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [isActionLoading, setIsActionLoading] = useState(false);

  const user = data?.data?.data;
  const userCookie = Cookies.get('user');  
  const adminId = userCookie ? JSON.parse(userCookie)?._id ?? '' : '';

  const depositMutation = useMutation(
    ({ userId, amount, adminId }) => UserService.deposit(userId, amount, adminId),
    {
      onMutate: () => setIsActionLoading(true),
      onSuccess: () => {
        toast({
          title: 'Deposit successful',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        queryClient.invalidateQueries(['user', userId]);
        onDepositClose();
        setAmount('');
      },
      onError: (error) => {
        toast({
          title: 'An error occurred',
          description: error.response?.data?.message || 'Unable to perform deposit',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      },
      onSettled: () => setIsActionLoading(false),
    }
  );

  const withdrawMutation = useMutation(
    ({ userId, amount, adminId }) => UserService.withdraw(userId, amount, adminId),
    {
      onMutate: () => setIsActionLoading(true),
      onSuccess: () => {
        toast({
          title: 'Withdrawal successful',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        queryClient.invalidateQueries(['user', userId]);
        onWithdrawClose();
        setAmount('');
      },
      onError: (error) => {
        toast({
          title: 'An error occurred',
          description: error.response?.data?.message || 'Unable to perform withdrawal',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      },
      onSettled: () => setIsActionLoading(false),
    }
  );

  const handleAction = () => {
    if (amount <= 0) {
      toast({
        title: 'Invalid amount',
        description: 'Amount must be greater than zero',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (actionType === 'deposit') {
      depositMutation.mutate({ userId, amount, adminId });
    } else if (actionType === 'withdraw') {
      withdrawMutation.mutate({ userId, amount, adminId });
    }
  };

  if (isLoading) {
    return <CustomSpinner />;
  }

  if (error) {
    return <Box>Error loading user details.</Box>;
  }

  return (
    <Box p={5} shadow="md" borderWidth="1px">
      <Text fontSize="xl" mb={4}>User Details</Text>
      <Box mb={4}>
        <Text><strong>Name:</strong> {user?.name}</Text>
        <Text><strong>Email:</strong> {user?.email}</Text>
        <Text><strong>Phone Number:</strong> {user?.phoneNumber}</Text>
        <Text><strong>Another Phone Number:</strong> {user?.altphoneNumber}</Text>

        <Text color={'green'} fontSize={'20px'}><strong>Wallet Balance:</strong> {user?.walletBalance}</Text>
        <Text><strong>Company Name:</strong> {user?.companyname}</Text>
        <Text><strong>Address:</strong> {user?.address}</Text>
        <Text><strong>Specialist:</strong> {user?.specialist}</Text>
        <Text><strong>Birthdate:</strong> {user?.birthdate ? new Date(user.birthdate).toLocaleDateString() : 'not applied'}</Text>
        <Text><strong>Verified:</strong> {user?.verified ? 'Yes' : 'No'}</Text>
        <Text><strong>Blocked:</strong> {user?.blocked ? 'Yes' : 'No'}</Text>
        <Text><strong>admin approved:</strong> {user?.approved ? 'Yes' : 'No'}</Text>
        <Text><strong>ID Number:</strong> {user?.idNumber}</Text>
        <Text><strong>ID Front Image:</strong> <img src={`${Api}/${user?.idImage?.path}`} alt="ID" /></Text>
        <Text><strong>ID Back Image:</strong> <img src={`${Api}/${user?.idbackImage?.path}`} alt="ID Back image" /></Text>
        <Text><strong>Created At:</strong> {new Date(user?.createdAt).toLocaleDateString()}</Text>
      </Box>

      <Button colorScheme="blue" onClick={() => setIsUpdateOpen(true)}>Update</Button>
      <Button
        ml={3}
        colorScheme="teal"
        onClick={() => { setActionType('deposit'); onDepositOpen(); }}
      >
        Add Money
      </Button>
      <Button
        ml={3}
        colorScheme="red"
        onClick={() => { setActionType('withdraw'); onWithdrawOpen(); }}
      >
        Withdraw
      </Button>
      <Button
        ml={3}
        colorScheme="blue"
        onClick={onTransactionsOpen}
      >
        View Transactions
      </Button>

      {/* Transactions Modal */}
      <Modal isOpen={isTransactionsOpen} onClose={onTransactionsClose} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Wallet Transactions</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {user?.walletTransactions.length > 0 ? (
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Amount</Th>
                    <Th>Type</Th>
                    <Th>Description</Th>
                    <Th>Date</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {user.walletTransactions.map((transaction) => (
                    <Tr key={transaction._id}>
                      <Td>{transaction.amount}</Td>
                      <Td>{transaction.type}</Td>
                      <Td>{transaction.description}</Td>
                      <Td>{new Date(transaction.timestamp).toLocaleString()}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            ) : (
              <Text>No transactions available.</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onTransactionsClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isDepositOpen || isWithdrawOpen} onClose={actionType === 'deposit' ? onDepositClose : onWithdrawClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{actionType === 'deposit' ? 'Deposit Money' : 'Withdraw Money'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Amount</FormLabel>
              <Input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme={actionType === 'deposit' ? 'blue' : 'red'} mr={3} onClick={handleAction} isLoading={isActionLoading}>
              {actionType === 'deposit' ? 'Deposit' : 'Withdraw'}
            </Button>
            <Button variant="ghost" onClick={actionType === 'deposit' ? onDepositClose : onWithdrawClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isUpdateOpen} onClose={() => setIsUpdateOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update User</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <UserUpdateForm user={user} onClose={() => { setIsUpdateOpen(false); refetch(); }} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default UserDetails;
